// src/components/ui/Icons.tsx
import * as React from "react";

type IconProps = {
  className?: string;
  direction?: "right" | "up" | "left" | "down";
  fill?: string;
  static?: boolean;
};

export const ArrowIcon: React.FC<
  Omit<IconProps, "fill" | "static"> & { width?: number; height?: number }
> = ({ className = "", direction = "right", width = 18, height = 19 }) => {
  let rotation = 0;
  if (direction === "down") rotation = 90;
  if (direction === "left") rotation = 180;
  if (direction === "up") rotation = -90;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 19"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={`stroke-current transition-transform duration-200 ${className}`}
      style={{ transform: `rotate(${rotation}deg)` }}
    >
      <path
        d="M1 9.5H17M17 9.5L11.4998 4M17 9.5L11.4998 15"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InstagramIcon: React.FC<IconProps> = ({
  className = "text-current",
  fill = "fill-current",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={`transition-colors duration-200 ${className}`}
  >
    <g clipPath="url(#clip0_1502_421)">
      <path
        className={fill}
        d="M9 1.62c2.405 0 2.69.011 3.635.053.88.04 1.354.187 1.67.31.418.162.72.358 1.034.671.316.317.51.616.671 1.034.123.316.27.794.31 1.67.042.949.052 1.234.052 3.635 0 2.405-.01 2.69-.052 3.635-.04.879-.187 1.354-.31 1.67-.162.418-.358.72-.671 1.034-.317.316-.616.51-1.034.671-.316.123-.794.27-1.67.31-.95.042-1.234.052-3.635.052-2.405 0-2.69-.01-3.635-.052-.88-.04-1.354-.187-1.67-.31a2.8 2.8 0 0 1-1.034-.671 2.8 2.8 0 0 1-.671-1.034c-.123-.316-.27-.794-.31-1.67-.042-.95-.052-1.234-.052-3.635 0-2.405.01-2.69.052-3.635.04-.88.187-1.354.31-1.67.162-.418.358-.72.671-1.034.317-.316.616-.51 1.034-.671.316-.123.794-.27 1.67-.31.946-.042 1.23-.052 3.635-.052M9 0C6.557 0 6.25.01 5.291.053 4.335.095 3.677.25 3.108.47a4.4 4.4 0 0 0-1.596 1.04 4.4 4.4 0 0 0-1.04 1.593C.25 3.677.094 4.331.051 5.287.012 6.252 0 6.557 0 9s.01 2.75.053 3.709c.042.956.197 1.614.418 2.183a4.4 4.4 0 0 0 1.04 1.596 4.4 4.4 0 0 0 1.593 1.037c.573.222 1.227.377 2.183.419.96.042 1.266.053 3.71.053s2.749-.011 3.709-.053c.956-.042 1.613-.197 2.183-.419a4.4 4.4 0 0 0 1.592-1.037 4.4 4.4 0 0 0 1.037-1.592c.222-.573.377-1.227.419-2.184.042-.96.052-1.265.052-3.708s-.01-2.75-.052-3.71c-.043-.956-.197-1.613-.419-2.183a4.2 4.2 0 0 0-1.03-1.6A4.4 4.4 0 0 0 14.896.476c-.573-.222-1.227-.377-2.184-.419C11.75.011 11.444 0 9 0"
      />
      <path
        className={fill}
        d="M9 4.377a4.624 4.624 0 0 0 0 9.246 4.624 4.624 0 0 0 0-9.246m0 7.622A3 3 0 1 1 9 6 3 3 0 0 1 9 12M14.885 4.194a1.08 1.08 0 1 1-2.159 0 1.08 1.08 0 0 1 2.16 0"
      />
    </g>
    <defs>
      <clipPath id="clip0_1502_421">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const FacebookIcon: React.FC<IconProps> = ({
  className = "text-current",
  fill = "fill-current",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
    className={`transition-colors duration-200 ${className}`}
  >
    <path
      className={fill}
      d="M9 0a9 9 0 0 0-2.174 17.735V11.75H4.97V9h1.856V7.815c0-3.063 1.386-4.483 4.394-4.483.57 0 1.554.112 1.956.223v2.493a12 12 0 0 0-1.04-.033c-1.475 0-2.045.559-2.045 2.012V9h2.94l-.506 2.75h-2.434v6.184A9 9 0 0 0 9 0"
    />
  </svg>
);

export const XIcon: React.FC<IconProps> = ({
  className = "text-current",
  fill = "fill-current",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
    className={`transition-colors duration-200 ${className}`}
  >
    <path
      className={fill}
      d="M13.745 1.428h2.53l-5.528 6.318 6.503 8.596h-5.092l-3.987-5.214-4.564 5.214H1.076l5.912-6.757L.75 1.428h5.22l3.606 4.766zm-.888 13.4h1.402L5.209 2.863H3.705z"
    />
  </svg>
);

export const PhoneIcon: React.FC<IconProps> = ({
  className = "text-current",
  fill = "fill-current",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="20"
    viewBox="0 0 24 24"
    aria-hidden="true"
    className={`transition-colors duration-200 ${className}`}
  >
    <path
      className={fill}
      d="M21 16.42v3.5a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 1.92 4.18 2 2 0 0 1 3.9 2h3.5a2 2 0 0 1 2 1.72c.12.9.32 1.78.6 2.63a2 2 0 0 1-.45 2.11L8.1 9.91a16 16 0 0 0 6 6l1.45-1.45a2 2 0 0 1 2.11-.45c.85.28 1.73.48 2.63.6A2 2 0 0 1 21 16.42z"
    />
  </svg>
);

export const EmailIcon: React.FC<IconProps> = ({
  className = "text-current",
  fill = "fill-current",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 305.616 305.616"
    width="20"
    height="20"
    aria-hidden="true"
    className={`transition-colors duration-200 ${className}`}
  >
    <path
      className={fill}
      d="M24.818 260.333c-24.459 0-.397-24.818-.397-24.818l62.359-68.532c6.065-6.663 17.769-16.78 24.612-11.199 6.842 5.58 15.98 16.888 22.344 23.268l12.896 12.907c6.913 6.119 12.232 0 12.232 0l13.195-12.999c6.418-6.326 15.61-17.362 22.463-22.496 6.853-5.134 18.509 4.629 24.557 11.308l61.994 68.5c24.47 24.062.397 24.062.397 24.062H24.818zM35.403 203.951c-6.065 6.668-14.925 18.264-20.913 24.998C7.729 236.548 0 242.318 0 229.009l.294-133.698c.022-9.013-.228-26.2 5.929-23.116 2.29 1.148 5.423 3.535 9.676 7.794l50.464 41.288c6.973 5.706 16.801 12.689 20.016 17.34 2.029 2.932 2.959 6.342.022 9.29l-50.498 56.044zM171.423 156.452c-6.967 5.716-14.539 13.826-18.406 13.837-3.867.005-11.58-7.919-18.58-13.598L24.634 67.621c-7-5.673-19.058-17.1-13.065-20.163 4.329-2.214 11.895-2.176 11.895-2.176h258.029c23.23 0 11.417 11.471 11.417 11.471L171.423 156.452zM291.11 228.949c-5.999-6.728-14.865-18.33-20.924-24.998l-50.969-56.05c-2.953-2.948-2.029-6.358 0-9.29 3.214-4.65 13.048-11.629 20.027-17.334l37.845-30.959c6.973-5.706 16.143-15.039 22.295-18.123 6.152-3.084 5.885 14.109 5.907 23.116l.326 133.698c0 13.309-7.74 7.539-14.511-.06z"
    />
  </svg>
);

export const CheckIcon: React.FC<IconProps> = ({
  className = "text-current",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    className={`transition-colors duration-200 ${className}`}
  >
    <circle cx="10" cy="10" r="10" fill="#000"></circle>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 9.871 8.085 14 16 6"
    ></path>
  </svg>
);

export const AddressIcon: React.FC<IconProps> = ({
  className = "text-current",
  fill = "fill-current",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    className={`transition-colors duration-200 ${className}`}
  >
    {/* Original icon is 12x20, centered horizontally inside 20x20 */}
    <g transform="translate(4 0)" className={fill}>
      <path d="M6.288 12.504c-3.295 0-6.016-2.768-6.016-6.19 0-3.421 2.72-6.158 6.016-6.158 3.294 0 6.015 2.768 6.015 6.19 0 3.421-2.69 6.19-6.015 6.19Zm0-11.104c-2.66 0-4.806 2.208-4.806 4.946s2.146 4.945 4.806 4.945 4.806-2.208 4.806-4.945S8.948 1.4 6.288 1.4Z" />
      <path d="M3.598 6.936a.615.615 0 0 1-.605-.622c0-1.866 1.481-3.39 3.295-3.39.333 0 .604.28.604.622a.615.615 0 0 1-.604.622c-1.149 0-2.086.964-2.086 2.146a.615.615 0 0 1-.604.622ZM6.317 20.156a.615.615 0 0 1-.604-.622v-7.652c0-.342.272-.622.604-.622.333 0 .605.28.605.622v7.652a.615.615 0 0 1-.605.622Z" />
    </g>
  </svg>
);

export const UserIcon: React.FC<IconProps> = ({
  className = "text-current",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="800"
    height="800"
    fill="none"
    viewBox="0 0 24 24"
    className={`transition-colors duration-200 ${className}`}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12.2 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10M3 22a9.71 9.71 0 0 1 9-7c4.12 0 7.63 2.91 9 7"
    ></path>
  </svg>
);

export const SpinnerIcon: React.FC<{ className?: string }> = ({ className = "" }) => (
  <svg
    className={`block h-[19px] w-[18px] animate-spin ${className}`}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      opacity="0.25"
    />
    <path
      d="M22 12a10 10 0 0 1-10 10"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const BasketIcon: React.FC<IconProps> = ({
  className = "text-current",
  fill = "fill-current",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={`transition-colors duration-200 ${className}`}
  >
    <path
      className={fill}
      d="M2.626 9.608v-.6zm0-3.941v.6zm17.948 0v-.6zM.6 7.637H0zm22 0H22zM4.074 18.684h.6v-.047l-.008-.047zm15.052 0-.592-.094-.008.047v.047zM5.232 4.541h-.6zM7.284.6v.6zm8.632 0V0zm2.052 3.94h-.6zM11 16.926a.6.6 0 1 0 1.2 0H11m1.2-4.504a.6.6 0 1 0-1.2 0h1.2M7.59 17.213a.6.6 0 0 0 1.157-.318l-.579.159zm-.042-4.669a.6.6 0 1 0-1.157.32l.579-.16zm6.948 4.35a.6.6 0 0 0 1.157.32l-.578-.16zm2.356-4.03a.6.6 0 0 0-1.157-.32l.579.16zm3.723-3.256v-.6H2.626v1.2h17.948zM2.626 5.667v.6h17.948v-1.2H2.626zM.6 7.637h.6c0-.741.623-1.37 1.426-1.37v-1.2C1.192 5.067 0 6.202 0 7.637zm2.026 1.97v-.6c-.803 0-1.426-.629-1.426-1.37H0c0 1.435 1.192 2.57 2.626 2.57zm17.948 0v.6c1.434 0 2.626-1.135 2.626-2.57H22c0 .741-.622 1.37-1.426 1.37zm0-3.94v.6c.803 0 1.426.629 1.426 1.37h1.2c0-1.435-1.192-2.57-2.626-2.57zm-16.5 13.017.592-.094L3.22 9.513l-.593.095-.592.094 1.447 9.077zm.957.916V19c-.223 0-.357-.166-.357-.316h-1.2c0 .862.722 1.516 1.557 1.516zm14.095-.916h-.6c0 .15-.134.316-.357.316v1.2c.835 0 1.557-.654 1.557-1.516zm1.448-9.076-.593-.095-1.447 9.077.592.094.593.095 1.447-9.077zM18.169 19.6V19H5.031v1.2h13.138zM5.232 6.23h.6V4.54h-1.2v1.69zM7.284.6v.6h8.632V0H7.284zM17.97 4.54h-.6v1.69h1.2V4.54zM15.915.6v.6c.485 0 .764.096.93.208.16.107.279.269.365.533.09.276.135.634.152 1.088.017.457.006.948.006 1.512h1.2c0-.525.011-1.07-.007-1.556-.018-.489-.067-.98-.21-1.417-.147-.45-.401-.864-.837-1.157-.428-.286-.965-.41-1.6-.41zM5.232 4.54h.6c0-.563-.012-1.054.005-1.51s.062-.813.152-1.09c.086-.263.205-.425.365-.532.167-.112.445-.208.93-.208V0C6.65 0 6.113.125 5.685.411c-.436.293-.69.708-.837 1.157-.143.437-.192.928-.21 1.417-.018.486-.006 1.031-.006 1.556zM11.6 16.927h.6v-4.504H11v4.504zm-3.433.128.579-.16-1.199-4.35-.578.16-.579.16 1.199 4.35zm6.907 0 .578.16 1.199-4.35-.578-.16-.579-.16-1.199 4.35z"
    />
  </svg>
);